<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ educationTitle }}</h3>
		<template v-if="educations?.length">
			<div class="flex text-sm" v-for="(edu, index) in educations" :key="index">
				<span class="mb-2 mr-4" v-if="edu.field?.name">
					{{ edu.field.name[locale] }}
				</span>
				<span class="ml-auto text-right" v-if="edu.level?.name">
					{{ edu.level.name[locale] }}
				</span>
			</div>
		</template>
		<template v-else>
			<span>{{ langs.noRequiredPaper[locale] }}</span>
		</template>

		<div class="h-[1px] w-full bg-dj-gray-light my-5"></div>

		<h3 class="text-lg md:text-xl font-medium mb-4">{{ languageTitle }}</h3>
		<template v-if="languages?.length">
			<div v-for="(lang, index) in languages" :key="index">
				<div class="flex text-sm">
					<span class="mr-4">{{ lang.language[locale] }}</span>
					<span v-if="lang.level" class="ml-auto text-right">{{ lang.level[locale] }}</span>
				</div>
				<span class="flex text-xs" v-if="index <= languages.length - 2">
					<span v-if="relation == 'or'">{{ langs.or[locale] }}</span>
					<span v-if="relation == 'and'">{{ langs.and[locale] }}</span>
				</span>
			</div>
		</template>
		<template v-else>
			<span>{{ langs.noRequiredLanguage[locale] }}</span>
		</template>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DjBox from "~/ui-kit/components/box/DjBox.vue";

// Define a reusable type for translated strings
type LocalizedString = {
	en: string;
	hu: string;
	ro: string;
	[key: string]: string; // Fallback for dynamic locales
};

// New structure coming from EducationResource
type EducationItem = {
	id: number;
	education_level_id: number;
	education_field_id: number;
	level: {
		id: number;
		name: LocalizedString;
	};
	field: {
		id: number;
		name: LocalizedString;
		education_level_id: number;
	};
	details?: unknown;
};

// Retained structure for Languages (assuming it didn't change)
type LanguageItem = {
	language: LocalizedString;
	level: LocalizedString;
};

export default defineComponent({
	name: "DjBoxEducations",
	components: { DjBox },
	props: {
		educationTitle: {
			type: String,
			default: "Education",
		},
		languageTitle: {
			type: String,
			default: "Language",
		},
		educations: {
			type: Array as PropType<EducationItem[]>,
			required: true,
		},
		languages: {
			type: Array as PropType<LanguageItem[]>,
			required: true,
		},
		relation: {
			type: String,
			default: "",
		},
		locale: {
			type: String,
			default: "hu",
		},
		langs: {
			type: Object,
			required: true,
		},
	},
});
</script>
